import React from 'react';
import padding from 'assets/scss/custom/padding.module.scss';
import { MenuItem } from '@material-ui/core';
import MySmallSelect from './MySmallSelect';
import { InputAdornment } from '@material-ui/core';

const Pricing = ({ price, setPrice, canEdit }) => {

  const handleUpdatePrice = value => {
    let regexDigitsOnly = /^[0-9]*\.?[0-9]*$/;
    if (regexDigitsOnly.test(value)) {
      setPrice(value);
    }
  };

  return (

      <MySmallSelect
        value={price}
        select={false}
        label="Your Price"
        price={price}
        onChange={e => handleUpdatePrice(e.target.value)}
        className={padding.bottom_sm}
        InputProps={{
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
          disabled: !canEdit
        }}
      >
      </MySmallSelect>

  );
};

export default Pricing;
